<!-- Contenedor principal de visualización -->
<div class="billing-display-container">
  <p-card>
    <ng-template pTemplate="header">
      <div class="display-header">
        <div class="header-left">
          <p-avatar 
            [label]="getBusinessInitials()" 
            size="large" 
            styleClass="mr-2"
            [style]="{'background-color': '#667eea', 'color': 'white'}">
          </p-avatar>
          <div class="header-info">
            <h4 class="business-name">{{ billing.businessName }}</h4>
            <span class="contract-number">Contrato: {{ billing.contractNumber }}</span>
          </div>
        </div>
        <div class="header-right">
          <p-tag 
            [value]="getLeaseStatus()" 
            [severity]="getLeaseStatusClass()"
            icon="fas fa-circle">
          </p-tag>
        </div>
      </div>
    </ng-template>

    <div class="billing-content">
      <!-- Información Fiscal -->
      <div class="info-section">
        <h5 class="section-title">
          <i class="fas fa-file-invoice mr-2"></i>
          Información Fiscal
        </h5>
        
        <div class="info-grid">
          <div class="info-item">
            <label class="info-label">Razón Social:</label>
            <span class="info-value">{{ billing.businessName }}</span>
          </div>
          
          <div class="info-item">
            <label class="info-label">Número de Contrato:</label>
            <span class="info-value">{{ billing.contractNumber }}</span>
          </div>
        </div>
      </div>

      <!-- Información de Pagos -->
      <div class="info-section">
        <h5 class="section-title">
          <i class="fas fa-credit-card mr-2"></i>
          Información de Pagos
        </h5>
        
        <div class="info-grid">
          <div class="info-item">
            <label class="info-label">Forma de Pago:</label>
            <span class="info-value">{{ getPaymentMethodLabel() }}</span>
          </div>
          
          <div class="info-item">
            <label class="info-label">Tipo de Pago:</label>
            <p-tag 
              [value]="getPaymentTypeLabel()" 
              [styleClass]="getPaymentTypeClass()">
            </p-tag>
          </div>
          
          <div class="info-item">
            <label class="info-label">Uso de CFDI:</label>
            <span class="info-value">{{ getCfdiUsageLabel() }}</span>
          </div>

        </div>
      </div>

      <!-- Conceptos a facturar -->
      <div class="info-section" *ngIf="conceptos.length > 0">
        <h5 class="section-title">
          <i class="fas fa-list-ol mr-2"></i>
          Conceptos a facturar
        </h5>

        <p-table [value]="conceptos" styleClass="p-datatable-sm conceptos-display-table" responsiveLayout="scroll">
          <ng-template pTemplate="header">
            <tr>
              <th style="width: 44px">#</th>
              <th style="width: 90px">Cantidad</th>
              <th>Clave</th>
              <th style="width: 110px">Unidad</th>
              <th style="width: 150px" class="text-right">Precio unit. (sin IVA)</th>
              <th>Comentarios</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-c>
            <tr>
              <td>{{ c.position }}</td>
              <td>{{ c.quantity }}</td>
              <td>{{ c.key }}</td>
              <td>
                <p-tag [value]="c.unit" [severity]="c.unit === 'PRODUCTO' ? 'warning' : 'info'"></p-tag>
              </td>
              <td class="text-right">{{ c.unitPrice | currency:'MXN':'symbol':'1.2-2' }}</td>
              <td>{{ c.comments || '—' }}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>

      <!-- Comentarios (si existen) -->
      <div class="info-section" *ngIf="hasComments()">
        <h5 class="section-title">
          <i class="fas fa-comment mr-2"></i>
          Comentarios
        </h5>
        
        <div class="comments-container">
          <p class="comments-text">{{ billing.comments }}</p>
        </div>
      </div>

      <!-- Información del Arrendamiento -->
      <div class="info-section" *ngIf="lease">
        <h5 class="section-title">
          <i class="fas fa-handshake mr-2"></i>
          Información del Arrendamiento
        </h5>
        
        <div class="info-grid">
          <div class="info-item">
            <label class="info-label">Folio:</label>
            <span class="info-value">{{ getLeaseInfo() }}</span>
          </div>
          
          <div class="info-item">
            <label class="info-label">Estado:</label>
            <p-tag 
              [value]="getLeaseStatus()" 
              [severity]="getLeaseStatusClass()">
            </p-tag>
          </div>
        </div>
      </div>

      <!-- Información de Fechas -->
      <div class="info-section">
        <h5 class="section-title">
          <i class="fas fa-calendar mr-2"></i>
          Fechas
        </h5>
        
        <div class="info-grid">
          <div class="info-item">
            <label class="info-label">Fecha de Creación:</label>
            <span class="info-value">{{ formatDate(billing.createdAt) }}</span>
          </div>
          
          <div class="info-item">
            <label class="info-label">Última Actualización:</label>
            <span class="info-value">{{ formatDate(billing.updatedAt) }}</span>
          </div>
        </div>
      </div>
    </div>
  </p-card>
</div>